type Props = {
    children: any;
}

const Container = ({ children }: Props) => {
  return (
        <div className='container grid gap-5 lg:gap-14 mx-auto lg:pt-0 py-10 px-5 lg:px-0'> {children} </div>
  )
}

export default Container
